import React, { useState } from 'react';

// Hover-triggered help tooltip. Renders a small "?" icon; on mouseenter
// shows a 290px-wide tooltip popup above the icon with a small triangle
// arrow pointing down. `text` supports `\n` line breaks via the inherited
// whiteSpace: pre-line. Extracted verbatim from
// prototypes/campaign-creation-prototype.jsx lines 467-537.
export const InfoTooltip = ({ text, theme }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const [hovered, setHovered] = useState(false);
  return (
    <span
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <span
        role="button"
        tabIndex={0}
        aria-label="More info"
        style={{
          width: 14, height: 14,
          borderRadius: '50%',
          border: `1px solid ${c.borderPrimary}`,
          color: c.textMuted,
          fontSize: '0.66rem',
          fontWeight: 700,
          fontFamily: t.fontFamily,
          display: 'inline-flex',
          alignItems: 'center', justifyContent: 'center',
          cursor: 'help',
          transition: 'all 120ms ease',
          background: hovered ? c.bgInput : 'transparent',
        }}
      >?</span>
      {hovered && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 8px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: c.bgCardSolid,
            border: `1px solid ${c.borderPrimary}`,
            borderRadius: 6,
            padding: '8px 10px',
            fontSize: '0.78rem',
            color: c.textPrimary,
            fontFamily: t.fontFamily,
            fontWeight: 400,
            lineHeight: 1.4,
            width: 290,
            whiteSpace: 'pre-line',
            textAlign: 'left',
            zIndex: 10,
            boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
            pointerEvents: 'none',
          }}
        >
          {text}
          <span style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0, height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: `6px solid ${c.borderPrimary}`,
          }} />
        </span>
      )}
    </span>
  );
};
